import { useState } from "react";

const TopTable = ({ data = [], onFilter }) => {
  const [showDateInput, setShowDateInput] = useState(false);
  const [date, setDate] = useState("");

  console.log(data)

  const handleDateChange = (e) => {
    const selectedDate = e.target.value;
    setDate(selectedDate);
    if (onFilter) onFilter(selectedDate); // send date to parent
  };

  return (
    <div className="p-5 bg-white rounded-md shadow-md max-h-[50vh] overflow-auto">
      
      {/* Filter Button */}
      <div className="mb-3 flex justify-end">
        <button
          onClick={() => setShowDateInput(!showDateInput)}
          className="px-4 py-2 bg-blue-600 text-white rounded shadow hover:bg-blue-700 transition"
        >
          Filter by Date
        </button>
      </div>

      {/* Date Input (shown only when button clicked) */}
      {showDateInput && (
        <div className="mb-4 flex justify-end">
          <input
            type="date"
            value={date}
            onChange={handleDateChange}
            className="border border-gray-300 rounded px-3 py-2"
          />
        </div>
      )}

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 rounded-lg shadow-sm">
          <thead className="bg-gray-400 text-white">
            <tr>
              <th className="py-3 px-4 text-left font-semibold">Kawasan</th>
              <th className="py-3 px-4 text-left font-semibold">ID</th>
              <th className="py-3 px-4 text-left font-semibold">Notic</th>
              <th className="py-3 px-4 text-left font-semibold">Email</th>
            </tr>
          </thead>

          <tbody className="bg-white divide-y divide-gray-200">
            {data && data.length === 0 ? (
              <tr>
                <td
                  className="py-4 px-4 text-center text-gray-500"
                  colSpan={4}
                >
                  No data available
                </td>
              </tr>
            ) : (
             data && data.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50 transition-colors">
                  <td className="py-3 px-4">{item.areaId}</td>
                  <td className="py-3 px-4">{item.id}</td>
                  <td className="py-3 px-4">{item.notic}</td>
                  <td className="py-3 px-4">{item.email}</td>
                </tr>
              ))
            )}
          </tbody>

        </table>
      </div>
    </div>
  );
};

export default TopTable;
